<template>
  <a :class="['btn btn-success add-to-cart', {disabled: isDisabled}]" @click="submit()" :disabled=isDisabled href="#">{{ btnText }}<i class="fa fa-cart-plus ml-2"></i></a>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import GetCookie from '../utils/getcookie'

  export default {
    props: [],

    data: function () {
      return {
        addingToCart: false
      }
    },

    computed: {
      isDisabled () {
        return !this.customstates.allCompleted() || this.$root.$data.fixedPreview.addingToCart
      },
      btnText () {
        return !this.$root.$data.fixedPreview.addingToCart ? 'Add to Cart' : 'Adding...'
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'customstates'
      ])
    },

    methods: {
      submit () {
        if (this.addingToCart) return

        this.addingToCart = this.$root.$data.fixedPreview.addingToCart = true

        let category = 'cart_error'
        this.$store.commit('alerts/remove', category)

        // Make sure all states are "dirty" so that they'll be validated
        this.$store.dispatch('customstates/setAllDirty')

        // Run the validation to make sure all states are updated
        this.$store.dispatch('customband/checkCompletion')

        if (this.customstates.allCompleted()) {

            console.log('Adding to cart!')

            // If this is a blank band, clear all print areas
            let curPrintStyleCode = this.customband.getPrintStyleCode()
            if (curPrintStyleCode === 'blank') {
              this.customband.clearAllPrintAreas()
            }

            let getCookie = new GetCookie()
            let axiosConfig = {
              headers: {
                'X-CSRFToken': getCookie.csrf()
              }
            }

            let postData = this.customband.getPostData()
            // console.log(`postData['form-0-data']`, _get(JSON.parse(postData['form-0-data']), 'areas.0.texts.0.colorFill.name'))
            // console.log(`postData['form-1-data']`, _get(JSON.parse(postData['form-1-data']), 'areas.0.texts.0.colorFill.name'))
            // console.log(`postData['form-2-data']`, _get(JSON.parse(postData['form-2-data']), 'areas.0.texts.0.colorFill.name'))
            // console.log(`postData['form-0-data']`, postData['form-0-data'])
            // console.log(`postData['form-1-data']`, postData['form-1-data'])
            // console.log(`postData['form-2-data']`, postData['form-2-data'])
            postData['band-submit'] = true
            const formData = new FormData()
            Object.keys(postData).forEach(key => formData.append(key, postData[key]))

            // Submit form
            axios.post('/builder/', formData, axiosConfig).then((resp) => {
              if (resp.data.hasOwnProperty('result')) {
                if (!resp.data.hasOwnProperty('error')) {
                  location.href = '/cart/'
                } else {
                  this.addingToCart = this.$root.$data.fixedPreview.addingToCart = false
                  // Show Error Message
                  let payload = {category, msg: resp.data.error}
                  this.$store.commit('alerts/add', payload)
                }
              } else {
                this.addingToCart = this.$root.$data.fixedPreview.addingToCart = false
                // console.log('resp', resp)
              }
            }).catch((error) => {
              this.addingToCart = this.$root.$data.fixedPreview.addingToCart = false

              if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
              } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request)
              } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message)
              }
            })
          } else {
            this.addingToCart = this.$root.$data.fixedPreview.addingToCart = false
          }
      }
    }
  }
</script>
